<a mat-list-item [ngStyle]="{'padding-left': (depth * 12) + 'px'}" (click)="onItemSelected(item)"
   [ngClass]="{'expanded': expanded}">
  {{ item.name }}
  <span fxFlex *ngIf="item.children && item.children.length">
    <span fxFlex></span>
    <mat-icon>{{ expanded ? 'expand_less': 'expand_more' }}</mat-icon>
  </span>
</a>
<div *ngIf="expanded">
  <app-sidenav-list *ngFor="let child of item.children" [module]="module" [item]="child" [depth]="depth + 1">
  </app-sidenav-list>
</div>
